<template>
  <button class="button" :class="variant">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonEl',
  props: {
    variant: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 6px 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  color: var(--color-white);
  border: 1px solid var(--color-blue);
  border-radius: 12px;
  background-color: var(--color-blue);
  transition: 0.35s border-color, 0.35s color, 0.35s background-color;
  cursor: pointer;

  &:disabled {
    pointer-events: none;
    opacity: 50%;
  }

  svg {
    margin-left: 10px;
  }

  &.white {
    color: var(--color-blue);
    border: 1px solid var(--color-gray-light);
    background-color: var(--color-gray-light);
  }
}
</style>
